import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { TooltipModule } from 'primeng/tooltip';
import { KeyDisplayNamePipe } from '../../pipes/key-display-name.pipe';
import { TagComponent } from '../tag/tag.component';

export interface ColumnData {
  name: string;
  displayName?: string;
  type?: string;
  hasTag?: boolean;
  tag?: string;
  buttonLabel?: string;
}

@Component({
    selector: 'app-basic-table',
    imports: [CommonModule, TooltipModule, KeyDisplayNamePipe, TagComponent],
    templateUrl: './basic-table.component.html',
    styleUrl: './basic-table.component.scss'
})
export class BasicTableComponent {
  @Input() tableData!: { columns: ColumnData[]; data: any[] };
  @Input() showIndex = false;
  @Input() tableName: string = '';
}
